/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Tab_AboutInputs */

const en_us2_exercise_sheet_tab_about = /** @type {(inputs: Exercise_Sheet_Tab_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

const pt_br2_exercise_sheet_tab_about = /** @type {(inputs: Exercise_Sheet_Tab_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre`)
};

const es_419_exercise_sheet_tab_about = /** @type {(inputs: Exercise_Sheet_Tab_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de`)
};

const pt_pt2_exercise_sheet_tab_about = /** @type {(inputs: Exercise_Sheet_Tab_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre`)
};

const fr_fr2_exercise_sheet_tab_about = /** @type {(inputs: Exercise_Sheet_Tab_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos`)
};

const de_de2_exercise_sheet_tab_about = /** @type {(inputs: Exercise_Sheet_Tab_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Info`)
};

const it_it2_exercise_sheet_tab_about = /** @type {(inputs: Exercise_Sheet_Tab_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Info`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {Exercise_Sheet_Tab_AboutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_tab_about = /** @type {((inputs?: Exercise_Sheet_Tab_AboutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Tab_AboutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_tab_about(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_tab_about(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_tab_about(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_tab_about(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_tab_about(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_tab_about(inputs)
	return en_us2_exercise_sheet_tab_about(inputs)
});
export { exercise_sheet_tab_about as "exercise-sheet.tab_about" }